import { SearchTripManagerInput, TripForDriverOutput } from '@allocab/allocab-driver-shared-types';
import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '../services/datastore/queryKeys';
import { driverApi } from '../services/network/Api';

type Input = Omit<SearchTripManagerInput, 'offset' | 'limit'> & Partial<Pick<SearchTripManagerInput, 'limit'>>;

const searchTrips = (input: Input) =>
  driverApi.post<SearchTripManagerInput, TripForDriverOutput, 'list'>('/trip/v1/search', {
    offset: 0,
    limit: 100,
    ...input,
  });

export const useSearchTrips = (input: Input) => {
  const searchTripsQuery = useQuery(queryKeys.user.searchTrips(input), () => searchTrips(input), {
    keepPreviousData: true,
  });

  return searchTripsQuery;
};
